import { faArrowLeft, faArrowUpRightFromSquare, faLink, faListCheck, faPlus, faTimes, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Chance } from 'chance';
import React, { Component } from 'react';
import { Badge, Button, Card, Col, Form, Image, Modal, Offcanvas, Row, Spinner } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import ImageViewer from 'react-simple-image-viewer';
import { toast } from 'react-toastify';
import { GET, POST } from '../../api';
import { Black, Blueberry, BlueCrayola, CerisePink, ChineseSilver, Cultured, CyanProcess, GraniteGray, Gray, LightSilver, SpanishGray, SunsetOrange, White } from '../../helpers/brand_colors_helper';
import { sendCloudMessage } from '../../helpers/cloud_message';
import { handleFormErrors } from '../../helpers/form_helpers';
import GetIcon from '../../helpers/icon_helper';
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';
import { t } from '../../helpers/translation_helper';
import { getExtension } from '../../helpers/general_helpers';
const chance = new Chance();

// API URL
const apiURL = process.env.REACT_APP_API_URL;

// Portal URL
const portalURL = process.env.REACT_APP_PORTAL_URL;
const appURL = process.env.REACT_APP_URL;

class AcademicActivityReflection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deleteModal: { show: false, id: 0, action: () => { }, title: null, desc: null },
            deleteModal2: { show: false, id: 0, action: () => { }, title: null, desc: null },

            academic_activities: null,
            activeTab: 'DETAILS',//DETAILS, REFLECTIONS,
            academic_activity_reflection_modal: {
                show: false,
                toggle: () => this.setState({ academic_activity_reflection_modal: { ...this.state.academic_activity_reflection_modal, show: !this.state.academic_activity_reflection_modal.show }, }, () => {
                    if (!this.state.academic_activity_reflection_modal.show) {
                        this.setState({
                            academic_activity_reflection: {
                                aar_id: null,
                                ut_id: null,
                                utt_id: null,
                                aa_id: null,
                                aar_is_root: 1,
                                aar_root_id: null,
                                aar_comment: '',
                            },
                            aar_attachments: [],
                        })
                    }
                })
            },
            academic_activity_reflection: {
                aar_id: null,
                ut_id: null,
                utt_id: null,
                aa_id: null,
                aar_is_root: 1,
                aar_root_id: null,
                aar_comment: '',
            },
            modalEditAAR: {
                show: false,
                data: null,
                toggleModal: (data = null) => this.setState({ modalEditAAR: { ...this.state.modalEditAAR, show: !this.state.modalEditAAR.show, data }, aar_attachments: [] })
            },
            aar_attachments: [],
            imageViewer: {
                show: false,
                images: [],
                currentIndex: 0,
                toggleImageViewer: (images = [], currentIndex = 0) => {
                    this.setState({ imageViewer: { ...this.state.imageViewer, show: (images.length > 0) ? true : false, images, currentIndex } })
                }
            },
            formSections: [
                {
                    uid: '0',
                    sectionGroup: ['Primary Year Programme', 'Middle Year Programme', 'Diploma Programme'],
                    active: true,
                    name: 'External Resources',
                    enum: 'external_resource',
                    desc: null,
                },
                {
                    uid: '1',
                    sectionGroup: ['General', 'Primary Year Programme', 'Middle Year Programme', 'UAE MOE'],
                    active: true,
                    name: 'Skills',
                    enum: 'learnskill',
                    desc: [],
                },
                {
                    uid: '2',
                    sectionGroup: ['General', 'Primary Year Programme', 'Middle Year Programme', 'UAE MOE'],
                    active: true,
                    name: 'Goals & Success Criteria',
                    enum: 'success',
                    desc: [],
                },
                {
                    uid: '3',
                    sectionGroup: ['Primary Year Programme', 'Middle Year Programme', 'Diploma Programme'],
                    active: true,
                    name: 'Approaches to learning',
                    enum: 'approaches_to_learning',
                    desc: null,
                },
                {
                    uid: '4',
                    sectionGroup: ['Primary Year Programme', 'Middle Year Programme', 'Diploma Programme'],
                    active: true,
                    name: 'Learner Profile',
                    enum: 'learner_profile',
                    desc: ['The aim of all IB programmes is to develop internationally minded people who, recognizing their common humanity and shared guardianship of the planet, help to create a better and more peaceful world. The IB learner profile represents 10 attributes valued by IB World Schools. We believe these attributes, and others like them, can help individuals and groups become responsible members of local, national and global communities.'],
                },
                {
                    uid: '5',
                    sectionGroup: ['Primary Year Programme', 'Middle Year Programme', 'Diploma Programme'],
                    active: true,
                    name: 'Objectives',
                    enum: 'curriculums',
                    desc: null,
                },
            ],
            dragAreaColor: {
                aar_attachments: SpanishGray,
                modalEditAAR: SpanishGray,
                toggleColor: (field, value) => this.setState({ dragAreaColor: { ...this.state.dragAreaColor, [field]: value } })
            },
        }
        this.filePickerAarAttachment = React.createRef();

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.academicActivityReflectionModal.show != this.props.academicActivityReflectionModal.show && this.props.academicActivityReflectionModal.show) {
            this.setState({ activeTab: 'DETAILS' }, () => {
                this.getAcademicActivityDetails({ aa_id: this.props.academicActivityReflectionModal.data.ut_type_table_id, ut_id: this.props.academicActivityReflectionModal.data.ut_id })
            })
        }
    }
    /**
      * Preview Upload File
      * @returns
      */
    readFile = (selectedFile) => {
        return new Promise(function (resolve, reject) {
            let reader = new FileReader();
            const allowedFiles = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'audio/x-m4a', 'audio/mp3', 'audio/mp4'];
            const allowedFilesDisplay = ['PDF', 'Image'];
            const allowedSize = 5000000;

            if (selectedFile.size) {
                if (selectedFile.size >= allowedSize) {
                    toast.error(t('Max file size allowed is ' + allowedSize / 1000000 + ' MB!'));
                    resolve({ type: 'error' });
                    return;
                } else if (!allowedFiles.includes(selectedFile.type)) {
                    toast.error(t('Allowed file type are ' + allowedFilesDisplay.toString()));
                    resolve({ type: 'error' });
                    return;
                } else {
                    if (selectedFile.type.includes('image')) {
                        reader.readAsDataURL(selectedFile);
                    } else if (selectedFile.type.includes('audio')) {
                        reader.readAsArrayBuffer(selectedFile);
                    } else {
                        reader.readAsText(selectedFile);
                    }
                }

                reader.onload = async (readerEvent) => {
                    resolve({ type: 'success', data: selectedFile, url: readerEvent.target.result });
                };
                reader.onerror = (error) => {
                    resolve({ type: 'error' });
                };
            } else {
                resolve({ type: 'error' });
            }
        });
    };

    addAttachment = (e) => {
        const selectedFiles = e.target.files;
        let allFiles = [];

        for (let i = 0; i < selectedFiles.length; i++) {
            allFiles.push(this.readFile(selectedFiles[i]));
        }

        Promise.all(allFiles).then((values) => {
            let attachments = e.target.multiple ? this.state[e.target.name] : null;
            let selectedFiles = values;
            selectedFiles.map((v, i) => {
                if (v.data.type) {
                    if (e.target.multiple) {
                        attachments.push({ url: v.url, data: v.data });
                    } else {
                        attachments = { url: v.url, data: v.data };
                    }
                }
            });
            this.setState({ [e.target.name]: attachments })
        });
    };

    getAcademicActivityDetails = async (data) => {
        const params = {
            aa_id: data.aa_id,
            ut_id: data.ut_id,
        };
        try {
            const res = await GET('academic-activities/get-academic-activity-details',
                {
                    params,
                }
            );

            if (res) {
                this.setState({ academic_activities: res.data })
            }

        } catch (err) {
            toast.error(t('Something went wrong while fetching Activity Details!'));
            console.log(err);
        }
    }

    deleteAcademicActivityReflection = async () => {
        const params = {
            aar_id: this.state.deleteModal.aar_id,
            created_by: this.state.deleteModal.created_by,
        };

        if (this.deleteAcademicActivityReflectionReq) {
            this.deleteAcademicActivityReflectionReq.abort();
        }
        this.deleteAcademicActivityReflectionReq = new AbortController();

        try {
            const res = await GET('academic-activities/delete-academic-activity-reflection',
                {
                    params,
                    signal: this.deleteAcademicActivityReflectionReq.signal,
                }
            );
            if (res) {
                let resData = res.data
                if (resData.type) {
                    let academic_activities = this.state.academic_activities
                    academic_activities.academic_activity_reflections = academic_activities.academic_activity_reflections.filter((v) => v.aar_id != params.aar_id)
                    this.setState({
                        academic_activities,
                        deleteModal: {
                            ...this.state.deleteModal, show: false, aar_id: null, created_by: null
                        }
                    })
                } else {
                    toast[resData.messageType](t(resData.message));
                    this.setState({
                        deleteModal: {
                            ...this.state.deleteModal, show: false, aar_id: null, created_by: null
                        }
                    })
                }
            }


        } catch (err) {
            toast.error(t('Something went wrong while deleting record!'));
            console.log(err);
        }
    }

    deleteAcademicActivityReflectionAttachment = async (deleteFrom) => {
        let deleteModal = this.state.deleteModal
        let deleteModal2 = this.state.deleteModal2
        const params = {}
        if (deleteFrom == 'aar_attachments') {
            params.aar_att_id = deleteModal2.aar_att_id
        } else {
            params.aar_att_id = deleteModal.aar_att_id
        }

        if (this.deleteAcademicActivityReflectionAttachmentReq) {
            this.deleteAcademicActivityReflectionAttachmentReq.abort();
        }
        this.deleteAcademicActivityReflectionAttachmentReq = new AbortController();

        try {
            const res = await GET('academic-activities/delete-academic-activity-reflection-attachment',
                {
                    params,
                    signal: this.deleteAcademicActivityReflectionAttachmentReq.signal,
                }
            );
            if (res) {
                let resData = res.data
                if (resData.type) {
                    if (deleteFrom == 'aar_attachments') {
                        let aar_attachments = this.state.aar_attachments
                        aar_attachments.splice(deleteModal2.aar_att_id_i, 1)
                        this.setState({
                            aar_attachments,
                            deleteModal2: {
                                ...this.state.deleteModal2, show: false, aar_id: null, created_by: null, aar_att_id: null, aar_att_id_i: null,
                            }
                        })
                    } else if (deleteFrom == 'academic_activities') {
                        let academic_activities = this.state.academic_activities
                        academic_activities.academic_activity_reflections[deleteModal.aar_id_i].academic_activity_reflection_attachments.splice(deleteModal.aar_att_id_i, 1)
                        this.setState({
                            academic_activities,
                            deleteModal: {
                                ...this.state.deleteModal, show: false, aar_id: null, created_by: null, aar_att_id: null, aar_att_id_i: null, aar_id_i: null,
                            }
                        })
                    }
                    toast[resData.messageType](t(resData.message));
                } else {
                    toast[resData.messageType](t(resData.message));
                    this.setState({
                        deleteModal: {
                            ...this.state.deleteModal, show: false, aar_id: null, created_by: null
                        }
                    })
                }
            }
        } catch (err) {
            toast.error(t('Something went wrong while deleting attachment record!'));
            console.log(err);
        }
    }


    getAcademicActivityReflection = async (aa_id, ut_id, aar_root_id = null) => {

        const params = {
            aa_id,
            ut_id,
            aar_root_id
        };

        if (this.getAcademicActivityReflectionReq) {
            this.getAcademicActivityReflectionReq.abort();
        }
        this.getAcademicActivityReflectionReq = new AbortController();

        try {
            const res = await GET('academic-activities/get-academic-activity-reflection',
                {
                    params,
                    signal: this.getAcademicActivityReflectionReq.signal,
                }
            );

            let resData = res
            let academic_activities = this.state.academic_activities
            resData.data.map((v, i) => {
                let alreadyThere = academic_activities.academic_activity_reflections.find((vv, ii) => vv.aar_id == v.aar_id)
                if (!alreadyThere) {
                    academic_activities.academic_activity_reflections.push(v)
                }
            })
            this.setState({ academic_activities: academic_activities })
        } catch (err) {
            toast.error(t('Something went wrong while fetching records!'));
            console.log(err);
        }
    }

    saveAcademicActivityReflection = async (aar_root_id = null) => {
        this.setState({ isSaving: true });

        if (this.saveAcademicActivityReflectionReq) {
            this.saveAcademicActivityReflectionReq.abort();
        }
        this.saveAcademicActivityReflectionReq = new AbortController();


        const { academic_activity_reflection, aar_attachments } = this.state;
        academic_activity_reflection.utt_id = this.props.academicActivityReflectionModal.data.utt_id
        academic_activity_reflection.ut_id = this.props.academicActivityReflectionModal.data.ut_id
        academic_activity_reflection.aa_id = this.props.academicActivityReflectionModal.data.ut_type_table_id
        academic_activity_reflection.aar_is_root = (aar_root_id) ? 0 : 1
        academic_activity_reflection.aar_root_id = aar_root_id

        if (!academic_activity_reflection.aar_comment) {
            this.setState({ isSaving: false });
            toast.error('Comment is required!');
            return
        }

        const fData = new FormData();
        aar_attachments.map((v, i) => {
            if (v.data.size) {
                fData.append('aar_attachments[]', v.data)
            }
        })

        fData.append('academic_activity_reflection', JSON.stringify(academic_activity_reflection));
        try {
            const res = await POST('academic-activities/save-academic-activity-reflection',
                fData,
                {
                    signal: this.saveAcademicActivityReflectionReq.signal,
                }
            );
            if (res) {
                let resData = res.data
                if (resData.type) {

                    let academic_activities = this.state.academic_activities
                    if (academic_activities.academic_activity_reflections) {
                        academic_activities.academic_activity_reflections = [resData.data, ...academic_activities.academic_activity_reflections]
                    } else {
                        academic_activities.academic_activity_reflections = [resData.data]
                    }
                    this.setState({
                        academic_activity_reflection: {
                            ...this.state.academic_activity_reflection,
                            aar_comment: '',
                        },
                        aar_attachments: [],
                        isSaving: false,
                        academic_activity_reflection_modal: {
                            ...this.state.academic_activity_reflection_modal,
                            show: false,
                        },
                        academic_activities
                    })

                    let academicActivityReflectionModalData = this.props.academicActivityReflectionModal.data

                    let title = 'New Reflection'
                    let body = 'on ' + academicActivityReflectionModalData.ut_type + ':' + academicActivityReflectionModalData.ut_title + ' by ' + this.props.authData.loginData.full_name
                    if (this.props.authData.loginData.role_id == 6) {
                        body = 'on ' + academicActivityReflectionModalData.ut_type + ':' + academicActivityReflectionModalData.ut_title + ' by ' + this.props.authData.loginData.full_name + ', Parent of ' + this.props.selectedChild.child_name
                    }
                    let data = { 'ut_id': academicActivityReflectionModalData.ut_id, 'actionType': 'user_timeline' }
                    sendCloudMessage(academicActivityReflectionModalData.created_by, title, body, data);
                } else {
                    this.setState({ isSaving: false });
                    if (resData.data) {
                        handleFormErrors(resData.data)
                    } else {
                        toast.error(resData.message);
                    }
                }
            }
        } catch (err) {
            toast.error('Something went wrong while sending message!');
            console.log(err);
            this.setState({ isSaving: false });
        }
    }

    updateAcademicActivityReflection = async (academic_activity_reflection) => {
        this.setState({ isSaving: true });

        if (this.saveAcademicActivityReflectionReq) {
            this.saveAcademicActivityReflectionReq.abort();
        }
        this.saveAcademicActivityReflectionReq = new AbortController();

        if (!academic_activity_reflection.aar_comment) {
            this.setState({ isSaving: false });
            toast.error('Comment is required!');
            return
        }

        const fData = new FormData();
        fData.append('academic_activity_reflection', JSON.stringify(academic_activity_reflection));
        this.state.aar_attachments.map((v, i) => {
            if (v.data.size) {
                fData.append('aar_attachments[]', v.data)
            }
        })

        try {
            const res = await POST('academic-activities/save-academic-activity-reflection',
                fData,
                {
                    signal: this.saveAcademicActivityReflectionReq.signal,
                }
            );
            if (res) {
                let resData = res.data
                if (resData.type) {


                    let academic_activities = this.state.academic_activities
                    academic_activities.academic_activity_reflections = academic_activities.academic_activity_reflections.map((v, i) => {
                        if (v.aar_id == resData.data.aar_id) {
                            return { ...v, ...resData.data }
                        }
                        return v
                    })
                    this.setState({
                        isSaving: false,
                        academic_activity_reflection_modal: {
                            ...this.state.academic_activity_reflection_modal,
                            show: false,
                        },
                        aar_attachments: [],
                        academic_activities,
                        modalEditAAR: {
                            ...this.state.modalEditAAR,
                            show: false,
                            data: null,
                        },
                        academic_activity_reflection: {
                            aar_id: null,
                            ut_id: null,
                            utt_id: null,
                            aa_id: null,
                            aar_is_root: 1,
                            aar_root_id: null,
                            aar_comment: '',
                        },
                    })

                    let academicActivityReflectionModalData = this.props.academicActivityReflectionModal.data

                    let title = 'Update Reflection'
                    let body = 'on ' + academicActivityReflectionModalData.ut_type + ':' + academicActivityReflectionModalData.ut_title + ' by ' + this.props.authData.loginData.full_name
                    if (this.props.authData.loginData.role_id == 6) {
                        body = 'on ' + academicActivityReflectionModalData.ut_type + ':' + academicActivityReflectionModalData.ut_title + ' by ' + this.props.authData.loginData.full_name + ', Parent of ' + this.props.selectedChild.child_name
                    }
                    let data = { 'ut_id': academicActivityReflectionModalData.ut_id, 'actionType': 'user_timeline' }
                    sendCloudMessage(academicActivityReflectionModalData.created_by, title, body, data);
                } else {
                    this.setState({ isSaving: false });
                    if (resData.data) {
                        handleFormErrors(resData.data)
                    } else {
                        toast.error(resData.message);
                    }
                }
            }
        } catch (err) {
            toast.error('Something went wrong while sending message!');
            console.log(err);
            this.setState({ isSaving: false });
        }
    }

    handleDragFileArea = (e, name) => {
        e.preventDefault();
        e.stopPropagation();

        if (e.type === "dragover") {
            this.state.dragAreaColor.toggleColor(name, CyanProcess)
        } else if (e.type === "dragleave") {
            this.state.dragAreaColor.toggleColor(name, GraniteGray)
        }
    }

    renderQsNums = () => {
        const { QsNums } = this.state;

        const qNums = QsNums.map((item, index) => {
            return (
                <button
                    key={index}
                    className={item.status}
                    onClick={() => this.scrollToQ(item.qid)}>
                    {index + 1}
                </button>
            );
        });

        return qNums;
    };
    renderExamQs = () => {
        const { examDetails } = this.state;
        const { Examsquest, ExamAnswers } = examDetails;

        const questions = Examsquest.map((item, index) => {
            // Exclude if the question is Audio Recording
            if (item.examsquesttype.eqtype_id == 9) {
                return false;
            }

            return (
                <Card
                    key={index}
                    className='mb-4 border-0'
                    id={'q-' + item.examsquest_id}>
                    <Card.Body>
                        <Row className='q-card-header'>
                            <Col className='q-type ps-0 pb-2'>
                                {index + 1}. {item.examsquesttype.eqtype_name}
                            </Col>
                            <Col className='d-flex justify-content-end pe-0 pb-2'>
                                <button
                                    onClick={() =>
                                        this.updateQNumStatus(
                                            index,
                                            'attemptlater'
                                        )
                                    }
                                    className='pe-2 ps-2 me-2 mark-attempt-later-btn'>
                                    {t('Mark as attempt later')}
                                </button>
                                <Badge
                                    bg='primary'
                                    className='me-2 d-flex align-items-center'>
                                    {t('Marks:') + ' ' + item.examsquest_grade}
                                </Badge>
                                {/* <Badge
                                    bg='warning'
                                    text='dark'
                                    className='me-2 d-flex align-items-center'>
                                    {t('Time:') +
                                        ' ' +
                                        item.examsquest_duration}
                                </Badge> */}
                                <Badge
                                    bg='success'
                                    className='d-flex align-items-center'>
                                    {t('Mandatory:') +
                                        ' ' +
                                        (item.is_mandatory == 1
                                            ? t('Yes')
                                            : t('No'))}
                                </Badge>
                            </Col>
                        </Row>
                        <div
                            className='ck-content'
                            dangerouslySetInnerHTML={{
                                __html: item.examsquest_desc1.replaceAll(
                                    '<input/>',
                                    '<input class="fitb fitb-' +
                                    item.examsquest_id +
                                    '" />'
                                ),
                            }}
                        />
                        {this.examQuestionOpts(
                            item.examsquesttype.eqtype_id,
                            item.examsquestoptions,
                            item.examsquest_id,
                            index,
                            ExamAnswers.length > 0
                                ? ExamAnswers.find((found_item) => {
                                    return (
                                        found_item.examsquest_id ==
                                        item.examsquest_id
                                    );
                                })
                                : null
                        )}
                    </Card.Body>
                </Card>
            );
        });

        return questions;
    };

    render() {
        const { user_id, full_name } = this.props.authData.loginData;
        let academicActivityReflectionModal = this.props.academicActivityReflectionModal
        let { imageViewer, academic_activities, formSections, activeTab, academic_activity_reflection, aar_attachments, academic_activity_reflection_modal, modalEditAAR } = this.state
        console.log('academicActivityReflectionModal', this.state, this.props);
        if (!academicActivityReflectionModal.show) {
            return null
        }

        let transdisciplinary_theme = academic_activities?.academic_activity_resources.find((v) => v.aar_type == 'transdisciplinary_theme')
        let transdisciplinary_theme_focus = academic_activities?.academic_activity_resources.filter((v) => v.aar_type == 'transdisciplinary_theme_focus')

        return <Offcanvas show={academicActivityReflectionModal.show} onHide={academicActivityReflectionModal.closeModal} style={{ height: '100%' }
        } placement='bottom' >
            <Offcanvas.Header style={{ borderBottom: 'solid 1px ' + ChineseSilver }}>
                <div className='d-flex flex-row justify-content-between align-items-center' style={{ width: '100%' }}>
                    <Offcanvas.Title>{t(academicActivityReflectionModal.modalTitle)}</Offcanvas.Title>
                    <div onClick={academicActivityReflectionModal.closeModal}>
                        <FontAwesomeIcon icon={faTimes} color={Black} />
                    </div>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body className='p-0'>
                <div className={'d-flex flex-row'} style={{ height: '100%' }} >
                    {/* ACTIVITY DETAILS */}
                    <div style={{ flex: 1, overflowY: 'auto', }} className='d-flex flex-column justify-content-between p-3'>
                        <div className='d-flex flex-column' style={{ fontSize: 13, overflowY: 'auto' }}>
                            <div style={{}}>
                                <Image src={(academicActivityReflectionModal.data.academic_activities.aa_image) ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_activities/' + academicActivityReflectionModal.data.academic_activities.aa_image : require('../../assets/images/noimage.png')} style={{ objectFit: 'contain', height: '9.5rem', width: '100%', borderRadius: 20 }} />
                            </div>

                            <div className='mb-3'>
                                <div style={{ fontWeight: '600' }} className='mb-1'>Description</div>
                                <div>{academicActivityReflectionModal.data.ut_description}</div>
                            </div>
                            <div className='d-flex flex-row mb-3'>
                                <div className='me-1'>
                                    <div style={{ color: Gray }}>Start</div>
                                    <Badge bg={'secondary'}>{academicActivityReflectionModal.data.start_datetime}</Badge>
                                </div>
                                <div>
                                    <div style={{ color: Gray }}>End</div>
                                    <Badge bg={'secondary'}>{academicActivityReflectionModal.data.end_datetime}</Badge>
                                </div>
                            </div>

                            {transdisciplinary_theme &&
                                <div style={{ border: 'solid 1px ' + ChineseSilver, borderRadius: 15, }} className='p-2 d-flex flex-column'>
                                    <div className='d-flex flex-row align-items-center mb-1'>
                                        <Image src={(transdisciplinary_theme.ala_description_2) ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_lesson_attributes/' + transdisciplinary_theme.ala_description_2 : require('../../assets/images/noimage.png')} style={{ objectFit: 'contain', height: 50, width: 50 }} />
                                        <div className='ms-1 d-flex flex-row flex-wrap'>{transdisciplinary_theme.ala_title}</div>
                                    </div>
                                    <div className='d-flex flex-row flex-wrap' style={{ flex: 1, fontSize: 12 }}>
                                        {transdisciplinary_theme_focus && transdisciplinary_theme_focus.map((v, i) => {
                                            return <div key={i} style={{ width: '50%' }} className={'pb-2 px-2'}>
                                                <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + Blueberry, height: '100%' }} className='px-2 py-1 d-flex flex-row flex-wrap'>{v.aar_title}</div>
                                            </div>
                                        })}
                                    </div>
                                </div>
                            }

                        </div>
                        {/* <div>
                            <Button variant='outline-primary' style={{ width: '100%' }} onClick={() => this.setState({ activeTab: (activeTab != 'DETAILS') ? 'DETAILS' : 'REFLECTIONS' })}>
                                {(activeTab == 'DETAILS') && <FontAwesomeIcon icon={faArrowLeft} className='me-2' />}
                                {(activeTab == 'DETAILS') ? 'Go Back' : 'Show more details'}
                            </Button>
                        </div> */}
                    </div>
                    <div style={{ flex: 3, backgroundColor: Cultured }} className='d-flex flex-column p-3'>

                        <div className='d-flex flex-row justify-content-between px-2'>
                            {/* REFLECTIONS */}
                            <div className='d-flex flex-row'>
                                <div className={(activeTab == 'DETAILS') ? 'btn-tab-item cursor-pointer active' : 'btn-tab-item cursor-pointer'}
                                    onClick={() => this.setState({ activeTab: 'DETAILS' })}>
                                    <FontAwesomeIcon icon={faListCheck} className='me-2' />
                                    {'DETAILS'}
                                </div>
                                <div className={(activeTab == 'REFLECTIONS') ? 'btn-tab-item cursor-pointer active' : 'btn-tab-item cursor-pointer'}
                                    onClick={() => this.setState({ activeTab: 'REFLECTIONS' })}>
                                    <FontAwesomeIcon icon={faListCheck} className='me-2' />
                                    {'REFLECTIONS'}
                                </div>
                                <div className={(activeTab == 'QUESTIONS') ? 'btn-tab-item cursor-pointer active' : 'btn-tab-item cursor-pointer'}
                                    onClick={() => this.setState({ activeTab: 'QUESTIONS' })}>
                                    <FontAwesomeIcon icon={faListCheck} className='me-2' />
                                    {'QUESTIONS'}
                                </div>
                            </div>
                            {(activeTab == 'REFLECTIONS') &&
                                <div className='d-flex flex-row align-items-center'>
                                    <Button variant='primary' size='sm' onClick={() => academic_activity_reflection_modal.toggle()}>
                                        <FontAwesomeIcon icon={faPlus} className='me-2' />
                                        {'Add New Reflection'}
                                    </Button>
                                </div>
                            }
                        </div>

                        {/* TABS => REFLECTIONS, QUESTIONS */}
                        {(activeTab == 'REFLECTIONS') &&
                            <div className='d-flex flex-column' style={{ flex: 1, fontSize: 13 }}>

                                <div className='p-3 d-flex flex-column' style={{ backgroundColor: White, borderRadius: 10, flex: 1 }}>
                                    <div style={{ height: '100%', overflowY: 'auto' }}>

                                        {academic_activities?.academic_activity_reflections.map((academic_activity_reflection_v, academic_activity_reflection_i) => {
                                            if (!academic_activity_reflection_v.aar_is_root) {
                                                return null
                                            }
                                            let viewConversation = academic_activity_reflection_v.viewConversation

                                            return <div className='p-3 mb-4' style={{ borderRadius: 10, border: 'solid 2px ' + Cultured }}>
                                                <div className='d-flex flex-row justify-content-between'>
                                                    <div></div>
                                                    <div className='d-flex flex-row align-items-center'>
                                                        {academic_activity_reflection_v.seen_on &&
                                                            <Badge bg='info' className='me-1' title={'Seen on ' + academic_activity_reflection_v.seen_on + ' by ' + academic_activity_reflection_v.seenUserData.name}>Seen</Badge>
                                                        }
                                                        <Badge bg='secondary' className='me-1'>{academic_activity_reflection_v.created_on}</Badge>
                                                        {academic_activity_reflection_v.created_by == user_id &&
                                                            <FontAwesomeIcon icon={faTrashCan} color={SunsetOrange} className='cursor-pointer mx-2' onClick={() =>
                                                                this.setState({
                                                                    deleteModal: {
                                                                        ...this.state.deleteModal, show: true, aar_id: academic_activity_reflection_v.aar_id, created_by: academic_activity_reflection_v.created_by, title: 'Are you sure?', desc: 'Delete record!', action: () => this.deleteAcademicActivityReflection()
                                                                    }
                                                                })
                                                            } />
                                                        }
                                                        {(user_id == academic_activity_reflection_v.created_by) &&
                                                            <div className='px-1 cursor-pointer mx-2' onClick={() => {
                                                                this.setState({
                                                                    academic_activity_reflection: {
                                                                        aar_id: academic_activity_reflection_v.aar_id,
                                                                        ut_id: academic_activity_reflection_v.ut_id,
                                                                        utt_id: academic_activity_reflection_v.utt_id,
                                                                        aa_id: academic_activity_reflection_v.aa_id,
                                                                        aar_is_root: academic_activity_reflection_v.aar_is_root,
                                                                        aar_root_id: academic_activity_reflection_v.aar_root_id,
                                                                        aar_comment: academic_activity_reflection_v.aar_comment,
                                                                    },
                                                                    aar_attachments: academic_activity_reflection_v.academic_activity_reflection_attachments.map((aara) => {
                                                                        return { ...aara, url: getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_activity_reflection_attachments/' + aara.aar_att_name, data: { type: getExtension(aara.aar_att_name) } }
                                                                    }),
                                                                    academic_activity_reflection_modal: {
                                                                        ...this.state.academic_activity_reflection_modal, show: true
                                                                    }
                                                                })
                                                                // modalEditAAR.toggleModal({ ...academic_activity_reflection_v })
                                                            }}>
                                                                {/* academic_activity_reflection_v.aar_id */}
                                                                <GetIcon icon={'LuPen'} className={'me-1 mb-1'} style={{ color: BlueCrayola }} />
                                                                {/* modalEditAAR */}
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                {academic_activity_reflection_v.academic_activity_reflection_attachments &&
                                                    <div className='d-flex flex-row flex-wrap mb-1'>
                                                        {academic_activity_reflection_v.academic_activity_reflection_attachments.map((vv, ii) => {
                                                            return <div key={ii} className='cursor-pointer position-relative' style={{ width: 60, height: 60 }}>
                                                                {vv.aar_att_name && (!vv.aar_att_name.includes('pdf'))
                                                                    ? (
                                                                        <img src={getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_activity_reflection_attachments/' + vv.aar_att_name} alt={t('Preview')} style={{ height: '90%', width: '90%', objectFit: 'cover' }} onClick={() => this.state.imageViewer.toggleImageViewer([getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_activity_reflection_attachments/' + vv.aar_att_name], 0)} />
                                                                    ) :
                                                                    (
                                                                        <a href={getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_activity_reflection_attachments/' + vv.aar_att_name} style={{ textDecoration: 'none', color: '#6c757d', fontSize: 13, }} target='_blank'>
                                                                            <img src={require('../../assets/images/pdf.png')} alt={t('PDF')} style={{ height: '90%', width: '90%', objectFit: 'cover' }} />
                                                                        </a>
                                                                    )}
                                                                {academic_activity_reflection_v.created_by == user_id &&
                                                                    <FontAwesomeIcon
                                                                        icon={faTrashCan}
                                                                        style={{ fontSize: 14, color: SunsetOrange, position: 'absolute', bottom: 6, right: 6, cursor: 'pointer', backgroundColor: White, borderRadius: 100, padding: 3 }}
                                                                        onClick={() =>
                                                                            this.setState({
                                                                                deleteModal: {
                                                                                    ...this.state.deleteModal, show: true, aar_att_id: vv.aar_att_id, aar_att_id_i: ii, aar_id_i: academic_activity_reflection_i, title: 'Are you sure?', desc: 'Delete Attachment!', action: () => this.deleteAcademicActivityReflectionAttachment('academic_activities')
                                                                                }
                                                                            })
                                                                        } />
                                                                }
                                                            </div>
                                                        })}
                                                    </div>
                                                }
                                                <div className='d-flex flex-row flex-wrap' style={{ whiteSpace: 'break-spaces' }}>
                                                    {/* {(academic_activity_reflection_v.aar_comment).split('\n').map((v) => <>{v}<br /></>)} */}
                                                    {academic_activity_reflection_v.aar_comment}
                                                </div>

                                                {(!viewConversation) &&
                                                    <div className='my-2' style={{ height: 6, width: '100%', backgroundColor: Cultured, height: 6, }}></div>
                                                }

                                                {/* CONVERSATION */}
                                                {(viewConversation) && academic_activities?.academic_activity_reflections.map((academic_activity_reflection_v2, academic_activity_reflection_i2) => {
                                                    if (academic_activity_reflection_v2.aar_root_id != academic_activity_reflection_v.aar_id) {
                                                        return null
                                                    }
                                                    return <div key={academic_activity_reflection_i2} className='my-2 p-3' style={{ width: '100%', backgroundColor: Cultured, borderRadius: 10 }}>
                                                        <div className='d-flex flex-row align-items-center justify-content-between'>
                                                            <div style={{ color: (user_id == academic_activity_reflection_v2.createdUserData.user_id) ? BlueCrayola : CerisePink }}>
                                                                <GetIcon icon={(user_id == academic_activity_reflection_v2.createdUserData.user_id) ? 'LuCornerDownLeft' : 'LuCornerDownRight'} className={'me-1 mb-1'} />
                                                                {academic_activity_reflection_v2.createdUserData.name}
                                                            </div>
                                                            <div className='d-flex flex-row align-items-center'>
                                                                {academic_activity_reflection_v2.created_by == user_id &&
                                                                    <FontAwesomeIcon icon={faTrashCan} color={SunsetOrange} className='cursor-pointer mx-2' onClick={() =>
                                                                        this.setState({
                                                                            deleteModal: {
                                                                                ...this.state.deleteModal, show: true, aar_id: academic_activity_reflection_v2.aar_id, created_by: academic_activity_reflection_v2.created_by, title: 'Are you sure?', desc: 'Delete record!', action: () => this.deleteAcademicActivityReflection()
                                                                            }
                                                                        })
                                                                    } />
                                                                }
                                                                {(user_id == academic_activity_reflection_v2.created_by) &&
                                                                    <div className='px-1 cursor-pointer mx-2' onClick={() => modalEditAAR.toggleModal({ ...academic_activity_reflection_v2 })}>
                                                                        {/* academic_activity_reflection_v.aar_id */}
                                                                        <GetIcon icon={'LuPen'} className={'me-1 mb-1'} style={{ color: BlueCrayola }} />
                                                                        {/* modalEditAAR */}
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        {academic_activity_reflection_v2.academic_activity_reflection_attachments &&
                                                            <div className='d-flex flex-row flex-wrap mb-1'>
                                                                {academic_activity_reflection_v2.academic_activity_reflection_attachments.map((vv2, ii2) => {
                                                                    return <div key={ii2} style={{ width: 50, height: 50 }}>
                                                                        {vv2.aar_att_name && (!vv2.aar_att_name.includes('pdf'))
                                                                            ? (
                                                                                <img src={getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_activity_reflection_attachments/' + vv2.aar_att_name} alt={t('Preview')} style={{ height: '100%' }} onClick={() => this.state.imageViewer.toggleImageViewer([getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_activity_reflection_attachments/' + vv2.aar_att_name], 0)} />
                                                                            ) :
                                                                            (
                                                                                <a href={getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_activity_reflection_attachments/' + vv2.aar_att_name} style={{ textDecoration: 'none', color: '#6c757d', fontSize: 13, }} target='_blank'>
                                                                                    <img src={require('../../assets/images/pdf.png')} alt={t('PDF')} style={{ height: '100%' }} />
                                                                                </a>
                                                                            )}
                                                                    </div>
                                                                })}
                                                            </div>
                                                        }
                                                        <div className='d-flex flex-row flex-wrap' style={{ whiteSpace: 'break-spaces' }}>
                                                            {/* {(academic_activity_reflection_v.aar_comment).split('\n').map((v) => <>{v}<br /></>)} */}
                                                            {academic_activity_reflection_v2.aar_comment}
                                                        </div>

                                                    </div>
                                                })}

                                                {/* ADD CHILD REFLECTION/COMMENT */}
                                                {viewConversation &&
                                                    <div className='my-3 d-flex align-items-end' style={{ gap: 10 }}>
                                                        {aar_attachments.length > 0 &&
                                                            <div className='d-flex flex-row'>
                                                                {aar_attachments.map((v, i) => {
                                                                    return <div className='p-1' style={{ height: 50, width: 50, display: 'flex', overflow: 'hidden', position: 'relative' }}>
                                                                        {(!v.data.type.includes('pdf')) && (
                                                                            <img src={v.url} alt={t('Preview')} style={{ height: '100%' }} />
                                                                        )}
                                                                        {(v.data.type.includes('pdf')) && (
                                                                            <img src={require('../../assets/images/pdf.png')} alt={t('PDF')} style={{ height: '100%' }} />
                                                                        )}
                                                                        {v.url && (
                                                                            <FontAwesomeIcon
                                                                                icon={faTrashCan}
                                                                                style={{ fontSize: 14, color: SunsetOrange, position: 'absolute', bottom: 6, right: 6, cursor: 'pointer', backgroundColor: White, borderRadius: 100, padding: 3 }}
                                                                                onClick={() => {
                                                                                    aar_attachments.splice(i, 1)
                                                                                    this.setState({ aar_attachments })
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                })}
                                                            </div>
                                                        }
                                                        <div style={{ flex: 1 }}>
                                                            <Form.Control type='text' as={'textarea'} rows="2" placeholder={t('Comment...')} onChange={(e) => this.setState({ academic_activity_reflection: { ...academic_activity_reflection, aar_comment: e.target.value } })} value={academic_activity_reflection.aar_comment} />
                                                        </div>
                                                        <div>
                                                            <Button disabled={this.state.isSaving} variant='primary' onClick={() => this.saveAcademicActivityReflection(academic_activity_reflection_v.aar_id)}>
                                                                <FontAwesomeIcon icon={faPlus} style={{ fontSize: 20 }} />
                                                                {this.state.isSaving && <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' className='mx-1' />}
                                                            </Button>
                                                        </div>
                                                    </div>
                                                }

                                                {/* viewConversation BTN */}
                                                {((academic_activity_reflection_v.totalCommentsConversationNew != null && academic_activity_reflection_v.totalCommentsConversationNew != 0) || [6, 20].includes(academic_activity_reflection_v.createdUserData.role_id)) &&
                                                    <div>
                                                        <Button size='sm' variant={(viewConversation) ? 'outline-success' : 'success'} className='d-flex flex-row justify-content-center align-items-center' onClick={() => {
                                                            if (!viewConversation) {
                                                                academic_activities.academic_activity_reflections[academic_activity_reflection_i].viewConversation = true
                                                                this.setState({ academic_activities }, () => {
                                                                    this.getAcademicActivityReflection(this.props.academicActivityReflectionModal.data.ut_type_table_id, this.props.academicActivityReflectionModal.data.ut_id, academic_activity_reflection_v.aar_id)
                                                                })
                                                            } else {
                                                                academic_activities.academic_activity_reflections[academic_activity_reflection_i].viewConversation = false
                                                                this.setState({ academic_activities })
                                                            }
                                                        }}>
                                                            {(viewConversation) ? t('Hide Comments') : t('Show Comments')}
                                                            {(academic_activity_reflection_v.totalCommentsConversationNew && academic_activity_reflection_v.totalCommentsConversationNew > 0)
                                                                ? <div className='ms-1 p-1 d-flex flex-row justify-content-center align-items-center' style={{ borderRadius: 50, backgroundColor: White, color: Black, height: 20, width: 20, fontSize: 12 }}>{academic_activity_reflection_v.totalCommentsConversationNew}</div>
                                                                : null
                                                            }
                                                        </Button>
                                                    </div>
                                                }

                                            </div>
                                        })}


                                    </div>
                                </div>

                            </div>
                        }
                        {(activeTab == 'QUESTIONS') &&
                            <div className='d-flex flex-column' style={{ flex: 1, fontSize: 13 }}>
                                <div className='p-3 d-flex flex-column' style={{ backgroundColor: White, borderRadius: 10, flex: 1 }}>
                                    <div style={{ height: '100%', overflowY: 'auto' }}>
                                        <div
                                            className='q-list-nums'
                                            ref={this.qListNums}>
                                            <h6
                                                className='text-center pb-2 mb-3'
                                                style={{
                                                    borderBottom: '#9b9b9b 1px solid',
                                                }}>
                                                {t('Question List')}
                                            </h6>
                                            <div className='q-list-nums-grid'>
                                                {this.renderQsNums()}
                                            </div>
                                        </div>
                                        <div id='exam-qs' ref={this.qList}>
                                            <div className='grey-section'>
                                                {this.renderExamQs()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {/* DETAILS TAB*/}
                        {(activeTab == 'DETAILS') &&
                            <div style={{ flex: 1, overflowY: 'auto' }}>

                                <div className='p-2 mb-2' style={{ backgroundColor: White, borderRadius: 10, }}>
                                    <div className='mb-2'>
                                        <div className='mb-1' style={{ fontSize: 16, fontWeight: '600' }}>{'Central Idea'}</div>
                                        <div>{academicActivityReflectionModal.data.academic_activities.aa_desc_cidea}</div>
                                    </div>
                                    <div className='mb-2'>
                                        <div className='mb-1' style={{ fontSize: 16, fontWeight: '600' }}>{'Unit'}</div>
                                        <div>{academicActivityReflectionModal.data.academic_activities.aa_desc_unit}</div>
                                    </div>
                                    <div className='mb-2'>
                                        <div className='mb-1' style={{ fontSize: 16, fontWeight: '600' }}>{'General'}</div>
                                        <div>{academicActivityReflectionModal.data.academic_activities.aa_desc_general}</div>
                                    </div>
                                </div>
                                {academic_activities?.academic_activity_attachments.length > 0 &&
                                    <div style={{ backgroundColor: White, borderRadius: 10 }} className=' mb-2'>
                                        <div className='d-flex flex-row px-3 py-2' style={{ borderBottom: 'solid 1px ' + LightSilver, fontSize: 16 }}>{t('Attachments')}</div>
                                        {/* DESC */}
                                        <div className='d-flex flex-row flex-wrap p-3' style={{ fontSize: 14 }}>
                                            {academic_activities?.academic_activity_attachments.map((att, att_i) => {
                                                return <div key={att_i} style={{ width: '25%' }} className={'pb-2 px-2'}>
                                                    <div style={{ backgroundColor: Cultured, borderRadius: 5 }} className='px-2 py-1 d-flex flex-row flex-wrap'>
                                                        <a href={portalURL + this.props.authData.centerData.center_uuid + '/academic_activity_attachments/' + att.aa_attach_name} className='w-100 d-flex flex-column align-items-center' target='_blank'>
                                                            <img
                                                                src={require(`../../assets/images/${att.aa_attach_type?.includes('pdf') ? 'pdf.png' : 'attachment.png'}`).default || require(`../../assets/images/${att.aa_attach_type?.includes('pdf') ? 'pdf.png' : 'attachment.png'}`)}
                                                                alt={att.aa_attach_type || 'attachment'}
                                                                style={{ width: 'auto', height: '100px', marginTop: 10, marginBottom: 10 }}
                                                            />
                                                            <div className='w-100 d-flex justify-content-between align-items-center'>
                                                                <span>{att.aa_attach_caption || 'Attachment'}</span>
                                                                <FontAwesomeIcon icon={faArrowUpRightFromSquare} className='me-1' />
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            })}
                                        </div>
                                    </div>
                                }
                                {formSections.map((v, i) => {

                                    let thisData = null
                                    if (v.enum == 'curriculums') {
                                        thisData = academic_activities?.curriculums
                                    } else {
                                        thisData = academic_activities?.academic_activity_resources.filter((vv) => vv.aar_type == v.enum)
                                    }
                                    if (!thisData || thisData.length <= 0) {
                                        return null
                                    }
                                    return <div key={i} style={{ backgroundColor: White, borderRadius: 10 }} className=' mb-2'>
                                        <div className='d-flex flex-row px-3 py-2' style={{ borderBottom: 'solid 1px ' + LightSilver, fontSize: 16 }}>{v.name}</div>
                                        {/* DESC */}
                                        <div className='d-flex flex-column'>
                                            {v.desc && v.desc.map((vv) => {
                                                return <div className='px-2 py-1' style={{ fontSize: 14, color: GraniteGray, fontStyle: 'italic' }}>{vv}</div>
                                            })}
                                        </div>
                                        <div className='d-flex flex-row flex-wrap p-3' style={{ fontSize: 14 }}>
                                            {thisData.map((vv, ii) => {
                                                if (v.enum == 'curriculums') {
                                                    return <div key={ii} style={{ width: '50%' }} className={'pb-2 px-2'}>
                                                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + Blueberry, height: '100%' }} className='px-2 py-1 d-flex flex-row flex-wrap'>{vv.curriculum_code}</div>
                                                    </div>
                                                } else if (v.enum == 'external_resource') {
                                                    return <div key={ii} style={{ width: '25%' }} className={'pb-2 px-2'}>
                                                        <div style={{ backgroundColor: Cultured, borderRadius: 5 }} className='px-2 py-1 d-flex flex-row flex-wrap'>
                                                            <a href={vv.aar_url} className='w-100 d-flex flex-column align-items-center' target='_blank'>
                                                                <img
                                                                    src={require(`../../assets/images/${vv.aar_url_type === 'youtube' ? 'youtube.png' :
                                                                        vv.aar_url_type === 'google_drive' ? 'g-drive.png' :
                                                                            vv.aar_url_type === 'my_folder' ? 'folder.png' :
                                                                                vv.aar_url_type === 'attachment' ? 'pdf.png' : 'folder.png'
                                                                        }`).default || require(`../../assets/images/${vv.aar_url_type === 'youtube' ? 'youtube.png' :
                                                                            vv.aar_url_type === 'google_drive' ? 'g-drive.png' :
                                                                                vv.aar_url_type === 'my_folder' ? 'folder.png' :
                                                                                    vv.aar_url_type === 'attachment' ? 'pdf.png' : 'folder.png'
                                                                            }`)}
                                                                    alt={vv.aar_url_type}
                                                                    style={{ width: 'auto', height: '100px', marginTop: 10, marginBottom: 10 }}
                                                                />
                                                                <div className='w-100 d-flex justify-content-between align-items-center'>
                                                                    <span>{vv.aar_title}</span>
                                                                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} className='me-1' />
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </div>
                                                } else {
                                                    return <div key={ii} style={{ width: '50%' }} className={'pb-2 px-2'}>
                                                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + Blueberry, height: '100%' }} className='px-2 py-1 d-flex flex-column'>
                                                            <div style={{ fontWeight: (vv.aar_desc) ? '600' : 'normal' }}>{vv.aar_title}</div>
                                                            {vv.aar_desc && <div className='d-flex flex-row flex-wrap'>{vv.aar_desc}</div>}
                                                        </div>
                                                    </div>
                                                }
                                            })}
                                        </div>
                                    </div>
                                })}
                            </div>
                        }

                    </div>
                </div>

                <Modal
                    size='lg'
                    show={academic_activity_reflection_modal.show}
                    onHide={() => academic_activity_reflection_modal.toggle()}>
                    <Modal.Header closeButton>
                        <Modal.Title>{(academic_activity_reflection.aar_id) ? t('Update Reflection') : t('New Reflection')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='my-3' style={{ gap: 10, display: 'flex', alignItems: 'flex-start' }}>

                            <div style={{ flex: 3 }}>
                                <Form.Control type='text' as={'textarea'} rows="10" placeholder={t('Type your reflection here...')} onChange={(e) => this.setState({ academic_activity_reflection: { ...academic_activity_reflection, aar_comment: e.target.value } })} value={academic_activity_reflection.aar_comment} />
                            </div>
                            <div className='d-flex flex-column' style={{ flex: 1 }}>
                                <div style={{ width: '100%' }}>
                                    <div className='d-flex flex-column justify-content-center align-items-center position-relative cursor-pointer' style={{ height: 150, width: '100%', border: 'dashed 1px ' + SpanishGray, backgroundColor: Cultured, borderRadius: 10, overflow: 'hidden', borderColor: this.state.dragAreaColor.aar_attachments }}
                                        onClick={() => {
                                            this.filePickerAarAttachment.current.click()
                                        }}
                                        onDragEnter={(e) => this.handleDragFileArea(e, 'aar_attachments')} onDragLeave={(e) => this.handleDragFileArea(e, 'aar_attachments')} onDragOver={(e) => this.handleDragFileArea(e, 'aar_attachments')} onDrop={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                                                this.addAttachment({ target: { files: e.dataTransfer.files, multiple: false, name: 'aar_attachments' } })
                                            }
                                        }}
                                    >
                                        <div className='d-flex flex-column justify-content-center align-items-center'>
                                            <GetIcon icon={'AiOutlineCamera'} style={{ fontSize: 30, color: SpanishGray }} />
                                            <div style={{ fontSize: 12, color: SpanishGray }}>{'Drag & Drop or'}</div>
                                            <div style={{ fontSize: 12, color: SpanishGray }}>{'Press to Upload Image'}</div>
                                        </div>
                                    </div>
                                    <Form.Control className='d-none' ref={this.filePickerAarAttachment} type='file' onChange={this.addAttachment} multiple name='aar_attachments' />
                                </div>
                                {aar_attachments.length > 0 &&
                                    <div className='d-flex flex-row flex-wrap mt-1' style={{ width: '100%' }}>
                                        {aar_attachments.map((v, i) => {
                                            return <div className='p-1' style={{ height: 'auto', width: '50%', display: 'flex', overflow: 'hidden', position: 'relative' }}>
                                                {((v.data && !v.data?.type.includes('pdf')) || (!v.data && !v.aar_att_name.includes('.pdf'))) && (
                                                    <img src={v.url || getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_activity_reflection_attachments/' + v.aar_att_name} alt={t('Preview')} style={{ width: '100%', objectFit: 'contain' }} />
                                                )}
                                                {((v.data && v.data?.type.includes('pdf')) || (!v.data && v.aar_att_name.includes('.pdf'))) && (
                                                    <img src={require('../../assets/images/pdf.png')} alt={t('PDF')} style={{ width: '100%', objectFit: 'contain' }} />
                                                )}
                                                {(v?.url || v.aar_att_id) && (
                                                    <FontAwesomeIcon
                                                        icon={faTrashCan}
                                                        style={{ fontSize: 14, color: SunsetOrange, position: 'absolute', bottom: 6, right: 6, cursor: 'pointer', backgroundColor: White, borderRadius: 100, padding: 3 }}
                                                        onClick={() => {
                                                            if (!v.aar_att_id) {
                                                                aar_attachments.splice(i, 1)
                                                                this.setState({ aar_attachments })
                                                            } else {
                                                                this.setState({
                                                                    deleteModal2: {
                                                                        ...this.state.deleteModal2, show: true, aar_att_id: v.aar_att_id, aar_att_id_i: i, title: 'Are you sure?', desc: 'Delete Attachment!', action: () => this.deleteAcademicActivityReflectionAttachment('aar_attachments')
                                                                    }
                                                                })
                                                            }
                                                        }}
                                                    />
                                                )}

                                                {/* {(!v.data.type.includes('pdf')) && (
                                                    <img src={v.url} alt={t('Preview')} style={{ width: '100%', objectFit: 'contain' }} />
                                                )}
                                                {(v.data.type.includes('pdf')) && (
                                                    <img src={require('../../assets/images/pdf.png')} alt={t('PDF')} style={{ width: '100%', objectFit: 'contain' }} />
                                                )}
                                                {v.url && (
                                                    <FontAwesomeIcon
                                                        icon={faTrashCan}
                                                        style={{ fontSize: 14, color: SunsetOrange, position: 'absolute', bottom: 6, right: 6, cursor: 'pointer', backgroundColor: White, borderRadius: 100, padding: 3 }}
                                                        onClick={() => {
                                                            aar_attachments.splice(i, 1)
                                                            this.setState({ aar_attachments })
                                                        }}
                                                    />
                                                )} */}
                                            </div>
                                        })}
                                    </div>
                                }
                            </div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button disabled={this.state.isSaving} variant='success' onClick={() => (academic_activity_reflection.aar_id) ? this.updateAcademicActivityReflection(academic_activity_reflection) : this.saveAcademicActivityReflection()}>
                            {'Add Reflection'}
                            {this.state.isSaving && <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' className='mx-1' />}
                        </Button>
                    </Modal.Footer>

                    <SweetAlert
                        show={this.state.deleteModal2.show}
                        warning
                        showCancel
                        confirmBtnText={t('Yes, delete it!')}
                        confirmBtnBsStyle='danger'
                        title={(this.state.deleteModal2.title) ? this.state.deleteModal2.title : t('Are you sure?')}
                        onConfirm={this.state.deleteModal2.action}
                        onCancel={() => this.setState({ deleteModal2: { ...this.state.deleteModal2, show: false, id: 0, action: () => { } } })}
                        focusCancelBtn>
                        {(this.state.deleteModal2.desc) ? this.state.deleteModal2.desc : t('Confirm Delete!')}
                    </SweetAlert>
                </Modal>

                <Modal show={modalEditAAR.show} backdrop='static' keyboard={false} onHide={() => {
                    modalEditAAR.toggleModal()
                }} size='xl'>
                    {modalEditAAR.show &&
                        <Modal.Header closeButton>
                            <Modal.Title>{'Editing'}</Modal.Title>
                        </Modal.Header>
                    }
                    {modalEditAAR.show &&
                        <Modal.Body>
                            <div className='my-3 d-flex align-items-end' style={{ gap: 10 }}>
                                <div style={{ flex: 1 }}>
                                    <Form.Control type='text' as={'textarea'} rows="2" placeholder={t('Comment...')} onChange={(e) => this.setState({ modalEditAAR: { ...modalEditAAR, data: { ...modalEditAAR.data, aar_comment: e.target.value } } })} value={modalEditAAR.data.aar_comment} />
                                </div>
                                <div>
                                    <Button disabled={this.state.isSaving} variant='primary' onClick={() => this.updateAcademicActivityReflection(modalEditAAR.data)}>
                                        <FontAwesomeIcon icon={faPlus} style={{ fontSize: 20 }} />
                                        {this.state.isSaving && <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' className='mx-1' />}
                                    </Button>
                                </div>
                            </div>
                        </Modal.Body>
                    }
                </Modal>

                {imageViewer.show && (
                    <ImageViewer
                        backgroundStyle={{ backgroundColor: 'rgba(0,0,0,0.8)' }}
                        src={imageViewer.images}
                        currentIndex={imageViewer.currentIndex}
                        disableScroll={true}
                        closeOnClickOutside={true}
                        onClose={imageViewer.toggleImageViewer}
                    />
                )}
                <SweetAlert
                    show={this.state.deleteModal.show}
                    warning
                    showCancel
                    confirmBtnText={t('Yes, delete it!')}
                    confirmBtnBsStyle='danger'
                    title={(this.state.deleteModal.title) ? this.state.deleteModal.title : t('Are you sure?')}
                    onConfirm={this.state.deleteModal.action}
                    onCancel={() => this.setState({ deleteModal: { ...this.state.deleteModal, show: false, id: 0, action: () => { } } })}
                    focusCancelBtn>
                    {(this.state.deleteModal.desc) ? this.state.deleteModal.desc : t('Confirm Delete!')}
                </SweetAlert>
            </Offcanvas.Body>
        </Offcanvas >
    }
}


const mapStateToProps = (state) => ({
    authData: state.auth.authData,
    selectedChild: state.selectedChild.data,
    languages: state.language.languages,
    defaultLanguage: state.language.defaultLanguage,
});

const mapDispatchToProps = () => ({

});

export default connect(mapStateToProps, mapDispatchToProps())(AcademicActivityReflection);
